module.exports = __webpack_public_path__ + "static/harvardLogo-12be420aeebd5474c7f956a7bafbc8d5.png";